export default function getEligibilityText(text) {
  let eligibilityText = "Check my eligibility";
  switch (text) {
    case CHECK_ELIGIBILITY:
      eligibilityText = "Check my eligibility";
      break;
    case CHECKING_ELIGIBILITY:
      eligibilityText = "Checking eligibility";
      break;
    case INIT_CHECK:
      eligibilityText = "Initialising checks";
      break;
    case ELIGIBILITY_CONFIRMED:
      eligibilityText = "Eligibility confirmed";
      break;
    case INIT_VERIFICATION:
      eligibilityText = "Initialising verification";
      break;
    case VERIFY_IDN:
      eligibilityText = "Verifying identity";
      break;
    case VERIFIED_IDN:
      eligibilityText = "Identity Verified";
      break;
  }
  return eligibilityText;
}

export const CHECK_ELIGIBILITY = "CHECK_ELIGIBILITY";
export const CHECKING_ELIGIBILITY = "CHECKING_ELIGIBILITY";
export const INIT_CHECK = "INIT_CHECK";
export const ELIGIBILITY_CONFIRMED = "ELIGIBILITY_CONFIRMED";
export const INIT_VERIFICATION = "INIT_VERIFICATION";
export const VERIFY_IDN = "VERIFY_IDN";
export const VERIFIED_IDN = "VERIFIED_IDN";
